import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconHomeLine: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"home-line"} maskId="square-filled-radius-0-stroke-1-IconHomeLine"><path fillRule="evenodd" clipRule="evenodd" d="M21 8.60312L12 1.35815L3 8.60312V21H21V8.60312ZM6 17V18H18V17H6Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconHomeLine;
